// YYYY年MM月DD日
export const dateFormat = (date: Date) => {
  return `${date.getFullYear()}年${date.getMonth() + 1}月${date.getDate()}日`;
};

// YYYY年MM月DD日
export const stringDateFormat = (dateString: string) => {
  return dateFormat(new Date(dateString));
};

// HH:mm
export const stringTimeFormat = (dateString: string) => {
  const date = new Date(dateString);
  return `${`${date.getHours()}`.padStart(
    2,
    "0"
  )}:${`${date.getMinutes()}`.padStart(2, "0")}`;
};

// {YYYY年}MM月DD日 Dynamic
export const stringDateFullDynamicFormat = (dateString: string) => {
  const date = new Date(dateString);
  return (
    (date.getFullYear() !== new Date().getFullYear()
      ? `${date.getFullYear()}年`
      : "") +
    `${date.getMonth() + 1}月${date.getDate()}日` +
    " " +
    `${`${date.getHours()}`.padStart(2, "0")}:${`${date.getMinutes()}`.padStart(
      2,
      "0"
    )}`
  );
};

export const stringDateToAge = (dateString: string) => {
  const date = new Date(dateString);
  const ageDifMs = Date.now() - date.getTime();
  const ageDate = new Date(ageDifMs);
  return Math.floor(Math.abs(ageDate.getUTCFullYear() - 1970) / 10) * 10;
};
